import { pxToRem, scrollbar, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const TemplateCardContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${pxToRem(200)};
  justify-content: space-between;
  background-image: url(${(props) => props.bg});
  background-position: center;
  padding: ${theme.spacing.xl} ${theme.spacing.lg};
  margin-bottom: ${theme.spacing.lg};
  border-radius: ${theme.borderRadius.md};
  border: ${pxToRem(1)} solid ${theme.semantic.border.default};
  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: ${theme.semantic.border.strong};
  }
`;
export const EmptyButton = styled.button `
  width: 100%;
  cursor: pointer;

  &:hover {
    ${TemplateCardContainer} {
      cursor: pointer;
    }
  }
`;
export const RightColumn = styled.div `
  display: flex;
  width: 100%;
  flex-direction: column;
  overflow: auto;
  ${scrollbar({ trackMargin: 'xl' })};
`;
export const HeaderContainer = styled.div `
  display: flex;
  width: 100%;
  height: 10rem;
  align-items: flex-end;
  gap: ${theme.spacing.md};
  padding: 0 ${theme.spacing['4xl']};
  padding-bottom: ${theme.spacing['2xl']};
  flex-shrink: 0;
  background-color: ${theme.semantic.surface.secondary};
  background-image: url(${(props) => props.bg});
  background-size: cover;
  background-position: center;
`;
